import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { SalesService } from 'src/app/services/sales.service';
import { phoneValidator } from '../../validators/form-validator';
import { Location, NgIf } from "@angular/common";
import { environment } from 'src/environments/environment';
import { GoogleAnalyticsService } from 'src/app/services/google-analytics.service';
import { RecaptchaModule, RecaptchaFormsModule } from 'ng-recaptcha';
import { NgxMaskModule } from 'ngx-mask';
@Component({
    selector: 'app-invite-a-friend',
    templateUrl: './invite-a-friend.component.html',
    styleUrls: ['./invite-a-friend.component.scss'],
    standalone: true,
    imports: [NgIf, FormsModule, ReactiveFormsModule, NgxMaskModule, RecaptchaModule, RecaptchaFormsModule]
})

export class InviteAFriendComponent implements OnInit {
  token: string = '';
  url : string = '';
  showCaptchaError:boolean = false;
  successMessage : boolean = false;
  captcha:string = environment.publicCaptchaKey;
  sendInviteForm: FormGroup = new FormGroup({
    phoneNumber: new FormControl('', [Validators.required,phoneValidator]),
  })
  office: any = {};

  constructor(
    public modal: NgbActiveModal,
    private salesService: SalesService,
    private location : Location,
    private googleAnalyticsService: GoogleAnalyticsService
  ) {
  }

  ngOnInit(): void {    
  }

  sendInvitation(): void {
    this.showCaptchaError = false;
    if(this.token !== ''){
      console.log(this.sendInviteForm.valid);
      this.url =  location.origin ;
      let phoneNum = this.sendInviteForm.controls['phoneNumber'].value;
      let captchaRes = this.token;
      this.salesService.sendInvitation(phoneNum, captchaRes).subscribe((res)=> {
        this.successMessage = true;
        this.googleAnalyticsService.sendKeyEvent('invite_friend', {
          timestamp: new Date().toISOString()
        })
      }
      );
    } else {
      this.showCaptchaError = true;
    }
}

}


